import './control-bar.scss';

export function ControlBar({ children }: React.PropsWithChildren) { 
    return ( 
        <div className="control-bar">
            {children}
        </div>
     );
}
